
import { Component } from 'vue-property-decorator'
import BaseLayout from '@/shared/components/BaseLayout.vue'
import { Action, Getter } from 'vuex-class'
import PaymentTypesDto from '@/api/dto/PaymentTypesDto'
import StorageMixin from '@/shared/mixins/StorageMixin.vue'

@Component({
    components: {
        BaseLayout
    },
    mixins: [StorageMixin]
})
export default class PaymentsMapping extends BaseLayout {
    private readonly STATE = {
        DEFAULT: 'default',
        LOADING: 'loading'
    }

    @Getter('paymentTypes')
    paymentTypes!: PaymentTypesDto

    @Action('loadPaymentsMapping')
    loadPaymentsMapping!: () => Promise<void>

    @Action('savePaymentsMapping')
    savePaymentsMapping!: (mapping: PaymentTypesDto) => Promise<void>

    private loadAnimate = this.STATE.DEFAULT

    async created (): Promise<void> {
        await this.handleCallback(async () => {
            await this.loadPaymentsMapping()
        })
    }

    async save (): Promise <void> {
        this.loadAnimate = this.STATE.LOADING

        await (this.$refs.baseLayout as BaseLayout).handleWithAlerts(async () => {
            await this.savePaymentsMapping(this.paymentTypes)
        }, this.$t('paymentsMapping.success').toString())

        this.loadAnimate = this.STATE.DEFAULT
    }
}
